import { deploymentsApi } from '../api/deploymentsApi';
import { deploymentQueryKey } from './useDeployment';
import {
  useDeploymentMutation,
  type DeploymentMutationOptions,
} from './_deploymentMutations';

interface ExecuteResult {
  jobId: string;
  deploymentId: string;
}

export const useExecuteDeployment = (
  deploymentId: string,
  options: DeploymentMutationOptions<ExecuteResult> = {}
) =>
  useDeploymentMutation<void, ExecuteResult>({
    mutationFn: () => deploymentsApi.execute(deploymentId),
    invalidate: (qc) => {
      qc.invalidateQueries({ queryKey: deploymentQueryKey(deploymentId) });
      qc.invalidateQueries({ queryKey: ['deployments'] });
    },
    errorLabel: 'Error executing deployment',
    ...options,
  });
